import { render, staticRenderFns } from "./quoted-shipments.vue?vue&type=template&id=2244df1f&"
import script from "./quoted-shipments.vue?vue&type=script&lang=js&"
export * from "./quoted-shipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports